import classNames from 'classnames'
import { useViewport } from 'hooks'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { hightlightCompanies } from 'utilities'

// Importar estilos de Swiper
import 'swiper/css'
import 'swiper/css/pagination'

interface TestimonialPDF {
  name: string
  link: string
}

const ClientsCarrousel = () => {
  const { width } = useViewport()
  const breakpoint = width > 430

  const itemClassName = classNames(
    'transition',
    'ease-in-out',
    'duration-300',
    'hover:filter-none',
    'hover:opacity-100',
    'py-6',
  )

  // Añadir cursor-pointer para indicar que es clicable
  const logoClassName = classNames('w-full', 'z-40', 'rounded-xl', 'shadow-lg')

  const testimonialsPDF: TestimonialPDF[] = [
    {
      name: 'profand',
      link: 'https://drive.google.com/file/d/1NI8UZsZkzSh-tri64HnYDmk1gCi0Yy4V/view?usp=sharing',
    },
    {
      name: 'keyterGroup',
      link: 'https://drive.google.com/file/d/1WhhlhIxv5HJYXdHs1KS3Ut2ycJ_Xwu7K/view?usp=sharing',
    },
    {
      name: 'grupoTragsa',
      link: 'https://drive.google.com/file/d/1KpDk6sTwDEMz9scATEU1m4Z48kPaLnqC/view?usp=sharing',
    },
    {
      name: 'sevillaTechPark',
      link: 'https://drive.google.com/file/d/1pRaA3IUoMp5pwqef6SrIIPC8hLm2M2vu/view?usp=sharing',
    },
    {
      name: 'fagor',
      link: 'https://drive.google.com/file/d/1wvrRUu2N8VHYStSnlR404L8B6Fb-mGki/view?usp=sharing',
    },
  ]

  const uniqueCompanies = Array.from(new Set(hightlightCompanies))

  // Duplicar slides si hay muy pocos para el loop (opcional, solo si persiste el problem)
  const slides =
    breakpoint && uniqueCompanies.length < 10
      ? [...uniqueCompanies, ...uniqueCompanies]
      : uniqueCompanies

  // Función para abrir el PDF si está disponible
  const handleClick = (company: string) => {
    const testimonial = testimonialsPDF.find(t => t.name === company)
    if (testimonial) {
      window.open(testimonial.link, '_blank', 'noopener noreferrer')
    }
  }

  return (
    <div className="relative z-10">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={breakpoint ? 20 : 5}
        slidesPerView={breakpoint ? 4.5 : 1}
        centeredSlides={true}
        loop={true}
        // loopAdditionalSlides={3}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
          bulletActiveClass: 'bg-blue-800',
        }}
        speed={500}
      >
        {slides.map((company: string, index: number) => {
          const hasPDF = testimonialsPDF.some(
            testimonial => testimonial.name === company,
          )

          return (
            <SwiperSlide key={index}>
              <div className="mb-6">
                <div
                  className={`${itemClassName} ${
                    company === 'iberostar' ? '!opacity-75' : ''
                  } ${breakpoint ? 'px-4' : 'px-0.5'} ${
                    hasPDF
                      ? 'cursor-pointer hover:scale-105 transition-transform'
                      : ''
                  }`}
                  onClick={() => hasPDF && handleClick(company)}
                >
                  <img
                    className={logoClassName}
                    src={`${process.env.REACT_APP_URL_S3}/images/testimonials/new/${company}.jpg`}
                    alt={company}
                    title={hasPDF ? 'Haz click para ver caso de éxito' : ''}
                  />
                </div>
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export default ClientsCarrousel
